export const getFranceData = () => ({
  name: "France",
  description: "La France est le berceau de la viticulture moderne, avec une tradition viticole millénaire et une diversité de terroirs exceptionnelle.",
  type: "country",
  regions: [
    { name: "Bordeaux", area: "120,000 ha", percentage: "15%", description: "Région des grands vins rouges" },
    { name: "Bourgogne", area: "28,000 ha", percentage: "3.5%", description: "Vins de terroir par excellence" },
    { name: "Champagne", area: "34,000 ha", percentage: "4.2%", description: "Région des vins effervescents" },
    { name: "Loire", area: "70,000 ha", percentage: "8.7%", description: "Vallée des vins blancs" },
    { name: "Rhône", area: "80,000 ha", percentage: "10%", description: "Vins du sud" },
    { name: "Provence", area: "27,000 ha", percentage: "3.4%", description: "Région des rosés" },
    { name: "Languedoc-Roussillon", area: "240,000 ha", percentage: "30%", description: "Plus grande région viticole" },
    { name: "Alsace", area: "15,000 ha", percentage: "1.9%", description: "Vins aromatiques" },
    { name: "Jura", area: "2,100 ha", percentage: "0.3%", description: "Vins uniques et traditionnels" },
    { name: "Sud-Ouest", area: "45,000 ha", percentage: "5.6%", description: "Vins de tradition" },
    { name: "Autres", area: "140,000 ha", percentage: "17.7%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Bordeaux", x: 25, y: 70, color: "#4B164C", size: 8 },
    { region: "Bourgogne", x: 45, y: 45, color: "#6d2c7a", size: 6 },
    { region: "Champagne", x: 40, y: 25, color: "#8a4a8a", size: 5 },
    { region: "Loire", x: 30, y: 55, color: "#a768a6", size: 7 },
    { region: "Rhône", x: 55, y: 65, color: "#c486c4", size: 7 },
    { region: "Provence", x: 65, y: 75, color: "#e2a4e2", size: 6 },
    { region: "Languedoc-Roussillon", x: 50, y: 80, color: "#f0c2f0", size: 9 },
    { region: "Alsace", x: 50, y: 35, color: "#f8e0f8", size: 4 },
    { region: "Jura", x: 55, y: 40, color: "#4B164C", size: 3 }
  ],
  statistics: {
    totalArea: "800,000 ha",
    production: "45 million hectolitres",
    regions: "11 régions principales",
    appellations: "360+ appellations",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Diversité climatique : océanique, continental, méditerranéen",
    soil: "Variété géologique exceptionnelle : calcaires, argiles, graves, granit",
    viticulture: "Tradition de qualité, rendements limités, terroir respecté"
  },
  wineStyles: {
    red: "Vins rouges structurés et élégants, avec un excellent potentiel de vieillissement",
    white: "Vins blancs secs et aromatiques, de la fraîcheur à la complexité",
    rosé: "Rosés élégants et fruités, parfaits pour l'apéritif",
    sparkling: "Champagne et vins effervescents de qualité mondiale"
  },
  history: "La viticulture française remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. La Révolution française a redistribué les terres viticoles. Le XIXe siècle a vu l'émergence des grands châteaux et la classification des vins. Aujourd'hui, la France reste la référence mondiale en matière de viticulture de qualité.",
  foodPairing: "Cuisine française traditionnelle, fromages affinés, gastronomie internationale"
}); 